import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OrcamentosEPacotesListarComponent } from './orcamentos-e-pacotes-listar.component';

@NgModule({
  imports: [RouterModule.forChild([
    {path: '', component: OrcamentosEPacotesListarComponent}
  ])],
  exports: [RouterModule]
})
export class OrcamentosEPacotesListarRoutingModule { }
